<template>
  <!--理财 3级-->
  <div>
    <header class="header">
      <div class="top">
        <div class="logo">
          <img src="../assets/img/logo1.png" class="img" alt="招商基金" />
          <!-- <img src="../assets/img/logo2.png" class="img" alt="投资者" /> -->
        </div>
        <div class="search" @click="$router.push({ path: '/search' })"></div>
      </div>
      <ul class="nav">
        <li>
          <router-link to="/" class="a">首 页</router-link>
        </li>
        <li
          v-for="(item, index) in navList"
          :key="item.id"
          @click="
            oneIndex = index
            getList(item.id)
          "
        >
          <router-link :to="'/licai?id=' + item.id + '&index=' + index" class="a" :class="index == oneIndex ? 'sel' : ''">
            {{ item.name }}</router-link
          >
        </li>
      </ul>
    </header>

    <div class="sy_banner">
      <van-swipe class="sy_swipe" :autoplay="3000" indicator-color="#BEBDB9" :show-indicators="false" @change="onChange">
        <van-swipe-item v-for="(item, i) in bannerList" :key="i">
          <img :src="item.image" class="img" />
        </van-swipe-item>
      </van-swipe>
      <div class="dots">
        <div class="nei">
          <i :class="i == current ? 'sel' : ''" v-for="(item, i) in bannerList" :key="i"></i>
        </div>
      </div>
    </div>
    <div class="modules-template" v-for="(item, index) in moduleList" :key="item.id">
      <!--视频-->
      <div v-if="item.show_data == 1">
        <div class="t_title">
          <span>{{ item.name }}</span>
          <div to="" class="more" @click="moreList(item, index)">{{ item.title }}></div>
        </div>
        <ul class="list_sp bg3">
          <li v-for="val in item.list" :key="val.id" @click="details(val.id, val)">
            <span class="state" v-if="val.is_new">NEW</span>
            <video :src="val.video_file" class="sp" :poster="val.image"></video>
            <div class="bo"></div>
          </li>
        </ul>
      </div>

      <!--图文-->
      <div v-if="item.show_data == 2">
        <div class="t_title">
          <span>{{ item.name }}</span>
          <div to="" class="more" @click="moreList(item, index)">{{ item.title }}></div>
        </div>
        <ul class="touzi_list bg2">
          <li v-for="val in item.list" :key="val.id" @click="details(val.id, val)">
            <img :src="val.image" class="img" />
            <div class="right">
              <div class="tit">{{ val.name }}</div>
              <div class="desc">{{ val.describe }}</div>
            </div>
          </li>
        </ul>
      </div>

      <!--文章-->
      <div v-if="item.show_data == 3">
        <div class="t_title">
          <span>{{ item.name }}</span>
          <div to="" class="more" @click="moreList(item, index)">{{ item.title }}></div>
        </div>
        <ul class="wengzhang_list">
          <li v-for="val in item.list" :key="val.id" @click="details(val.id, val)">
            <div class="tit">{{ val.name }}</div>
            <div class="desc">{{ val.describe }}</div>
          </li>
        </ul>
      </div>

      <!--图片-->
      <div v-if="item.show_data == 4">
        <div class="t_title">
          <span>{{ item.name }}</span>
          <div to="" class="more" @click="moreList(item, index)">{{ item.title }}></div>
        </div>
        <ul class="img_list bg3">
          <li v-for="val in item.list" :key="val.id" @click="showImg(val.image)">
            <div class="nei">
              <img :src="val.image" class="img" />
              <div class="tit">{{ val.name }}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="di_tishi">
      <strong>风险提示 ：</strong><br />
      市场有风险，投资须谨慎。本网站相关观点为当前观点，未来可能随着市场的变化而变化，亦不构成任何投资建议及基金投资收益的保证。
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  data() {
    return {
      id: '',
      oneIndex: '',
      current: 0,
      cards_id: '',
      bannerList: [],
      navList: [],
      moduleList: [],
    }
  },
  created() {
    this.id = this.getQueryValue('id')
    this.cards_id = this.getQueryValue('cards_id')
    this.oneIndex = this.getQueryValue('index')
    this.getNav()
    this.getList()
    this.getBanner()
  },
  methods: {
    //轮播
    onChange(index) {
      this.current = index
    },
    async getNav() {
      const res = await this.axios.get('/index/tabs')
      if (res.code === 1) {
        this.navList = res.data
      }
    },
    async getBanner() {
      const res = await this.axios.get(`/item_banners/index?items_id=${this.id}&cards_id=${this.cards_id}`)
      if (res.code === 1) {
        console.log(res)
        this.bannerList = res.data
      }
    },
    async getList() {
      const res = await this.axios.get(`/contents/index?items_id=${this.id}&cards_id=${this.cards_id}`)
      console.log(res)
      if (res.code === 1) {
        this.moduleList = res.data
        console.log(this.moduleList)
        this.moduleList.forEach((item) => {
          item.title = '展开'
          if (item.content.length >= 4) {
            item.all = item.content
            item.content = item.content.slice(0, 4)
            item.list = item.content
          } else {
            item.list = item.content
          }
        })
      }
    },
    moreList(item, index) {
      if (item.all) {
        if (item.all.length > item.list.length) {
          this.$set(this.moduleList[index], 'list', this.moduleList[index].all)
          item.title = '缩回'
          this.$forceUpdate()
        } else {
          this.$set(this.moduleList[index], 'list', this.moduleList[index].content)
          item.title = '展开'
          this.$forceUpdate()
        }
      } else {
        this.$toast('没有更多了')
      }
      console.log(this.moduleList)
    },
    showImg(img) {
      ImagePreview([img])
    },
    details(id, val) {
      if (val.url) {
        location.href = val.url
      } else {
        if (val && val.is_pdf) {
          window.open(val.pdf_file)
        } else {
          this.$router.push({ path: `/levelThree?id=${id}` })
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: -0.6rem;
  .top {
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 0.3rem;
    background: #fff;
    .logo {
      display: flex;
      height: 1rem;
      align-items: center;
      .img {
        max-height: 0.46rem;
        margin-right: 0.4rem;
      }
    }
    .search {
      width: 1rem;
      height: 1rem;
      background: url(../assets/img/search.png) no-repeat center center;
      background-size: 0.41rem;
    }
  }
  .nav {
    width: 100%;
    background: url(../assets/img/bg_01.png) no-repeat left top;
    background-size: 100% 100%;
    height: 0.96rem;
    line-height: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    li {
      padding: 0;
      margin: 0;
      width: 50%;
      text-align: center;
      height: 0.96rem;
      display: flex;
    }
    .a {
      width: 100%;
      color: #fff;
      font-size: 0.28rem;
      height: 0.8rem;
      display: inline-block;
      line-height: 0.8rem;
      position: relative;
      &.sel {
        font-weight: bold;
        background: url(../assets/img/bg_02.png) no-repeat center 85%;
        background-size: auto 0.02rem;
      }
    }
  }
}
.main {
  padding: 0 0.32rem;
}
.sy_banner {
  position: relative;
  .sy_swipe {
    .img {
      display: block;
      width: 100%;
    }
  }
  .dots {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 10;
    height: 0.4rem;
    background-size: 100% 100%;
    text-align: right;
    padding-right: 0.3rem;
    line-height: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row-reverse;
    .nei {
      display: flex;
    }
    i {
      width: 0.1rem;
      height: 0.1rem;
      background: #fff;
      border-radius: 5px;
      display: inline-block;
      margin-left: 8px;
      transition: 0.4s;
    }
    .sel {
      width: 0.9rem;
    }
  }
}
.t_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.3rem;
  box-sizing: border-box;
  padding: 0 0.32rem;
  span {
    height: 0.74rem;
    line-height: 0.74rem;
    font-size: 0.3rem;
    color: #272a2c;
    font-weight: bold;
  }
  .more {
    line-height: 0.5rem;
    color: #666666;
    font-size: 0.22rem;
  }
}
.list_sp {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 0 0.32rem;
  justify-content: space-between;
  box-sizing: border-box;
  margin-bottom: -0.4rem;
  padding-bottom: 0.4rem;
  li {
    width: 46%;
    height: 3.6rem;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 0.15rem;
    background: #fff;
    position: relative;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
    margin-bottom: 0.4rem;
    .state {
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      padding: 0 5px;
      line-height: 0.26rem;
      font-size: 0.14rem;
      position: absolute;
      top: 5px;
      right: 5px;
    }
    .bo {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background: url(../assets/img/bo.png) no-repeat center center;
      background-size: 0.56rem;
      left: 0;
    }
    .sp {
      width: 100%;
      display: block;
      height: 100%;
      background: #000;
      object-fit: cover;
    }
  }
}
.touzi_list {
  padding: 0 0.32rem;
  padding-bottom: 1rem;
  margin-bottom: -0.7rem;
  li {
    margin-bottom: 0.18rem;
    background: #fff;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    position: relative;
    align-items: center;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
  }
  .img {
    width: 2.9rem;
    height: 1.5rem;
    object-fit: cover;
    flex-shrink: 0;
  }
  .type {
    position: absolute;
    top: 3px;
    right: 0.15rem;
    line-height: 0.24rem;
    background: #f7eaec;
    padding: 0 5px;
    color: #e34f66;
    font-size: 0.18rem;
  }
  .right {
    padding: 0.2rem;
    width: 100%;
    .tit {
      padding-left: 0.16rem;
      background: url(../assets/img/bg_05.png) no-repeat left top;
      background-size: 0.08rem;
      color: #4d4d4d;
      font-size: 0.3rem;
      line-height: 0.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .desc {
      color: #999999;
      line-height: 0.24rem;
      font-size: 0.2rem;
      padding-left: 0.16rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}

.wengzhang_list {
  background: #ffffff;
  box-shadow: -2px 0.2rem 0.21rem 0px rgba(245, 219, 204, 0.74);
  border-radius: 0.1rem;
  margin: 0 0.32rem;
  margin-bottom: 0.9rem;
  padding: 0.2rem 0.28rem;
  li {
    padding: 0.2rem 0;
    border-bottom: 1px solid #e7e7e7;
    &:last-child {
      border: 0;
    }
  }
  .tit {
    padding-left: 0.16rem;
    background: url(../assets/img/bg_05.png) no-repeat left top;
    background-size: 0.08rem;
    color: #4d4d4d;
    font-size: 0.3rem;
    line-height: 0.5rem;
  }
  .desc {
    color: #999999;
    line-height: 0.24rem;
    font-size: 0.2rem;
    padding-left: 0.16rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.img_list {
  display: flex;
  padding: 0 0.22rem;
  box-sizing: border-box;
  padding-bottom: 1rem;
  margin-bottom: -0.7rem;
  flex-wrap: wrap;
  li {
    width: 33.33%;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-bottom: 0.22rem;
  }
  .nei {
    background: #fff;
    box-shadow: -2px 0.2rem 0.21rem 0px rgba(245, 219, 204, 0.74);
    border-radius: 0.1rem;
    overflow: hidden;
    .img {
      width: 100%;
      display: block;
      height: 2.15rem;
      object-fit: cover;
    }
    .tit {
      text-align: center;
      height: 0.9rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #4d4d4d;
      font-size: 0.24rem;
    }
  }
}
.bg1 {
  background: url(../assets/img/bg_06.png) no-repeat left bottom;
  background-size: 5.3rem;
}
.bg2 {
  background: url(../assets/img/bg_06.png) no-repeat right bottom;
  background-size: 5.3rem;
}
.bg3 {
  background: url(../assets/img/bg_07.png) no-repeat left bottom;
  background-size: 3.6rem;
  padding-bottom: 0.8rem;
  margin-bottom: -0.7rem;
}
.di_tishi {
  padding: 0.6rem 0.32rem;
  color: rgba(153, 153, 153, 0.59);
  line-height: 0.28rem;
  font-size: 0.18rem;
  font-weight: normal;
}
</style>
